import React, { Component, Fragment } from 'react'
import { ControlMissionRoute } from '../../routing'
import Breadcrumbs from '../../shared/Breadcrumbs'

export class ControlMissionPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ControlMissionRoute />
            </Fragment>
        )
    }
}
